import { ApolloClient, from } from '@apollo/client';
import { createCache } from './cache';
import { createHttpLink } from './links/httpLink';
import { createRestLink } from './links/restLink';
import { loadTypeDefs } from './clientTypeDefs';
import { createThrottleLink } from './links/throttleLink';
import { insertIf } from '@cobra/helpers/array-helpers';

const TYPE_DEFS = loadTypeDefs();
const restLink = createRestLink();
const httpLink = createHttpLink();
const throttleLink = createThrottleLink(500);

const cache = createCache();

export const client = new ApolloClient({
    link: from([...insertIf(process.env.NODE_ENV === 'development', throttleLink), restLink, httpLink]),
    cache,
    typeDefs: [TYPE_DEFS],
});
